<template>
  <div class="">
    <div class="hasPadding c-search-div">
      <div class="c-search-content">
        <span class="icon iconfont icon-search"></span>
        <input
          class="c-search-input"
          type="text"
          placeholder="搜索"
          v-model="word"
          @keyup.enter="handleEnter"
        />
      </div>
      <p class="c-search-cancel" @click="cancel">取消</p>
    </div>
    <div class="line"></div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: '',
  props: {},
  data() {
    return {
      word: ''
    };
  },
  methods: {
    ...mapActions(['searchWordActions']),
    cancel() {
      this.$router.go(-1);
    },
    handleEnter() {
      this.searchWordActions(this.word);
      this.$emit('search-input-enter', 'enter');
    }
  },
  computed: {
    ...mapState({
      keyword: state => state.search.keyword
    })
  },
  watch: {
    keyword(v) {
      this.word = v;
    }
  },
  components: {},
  created() {}
};
</script>
<style lang="less" scoped>
.line {
  width: 100%;
  height: 1px;
  background: #ffffff;
  box-shadow: 0 1px 0 0 rgba(216, 216, 216, 0.5);
  margin-top: 0.2rem /* 15/75 */;
}

.c-search-div {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  .c-search-cancel {
    width: 1rem /* 60/75 */;
    font-size: 0.4rem /* 30/75 */;
    color: #027cfa;
    text-align: center;
    margin-left: 0.4rem /* 30/75 */;
  }
  .c-search-content {
    width: 100%;
    height: 0.7733rem /* 58/75 */;
    position: relative;
    background: #f2f2f2;
    border-radius: 0.1067rem /* 8/75 */;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0.2667rem /* 20/75 */;
    span {
      font-size: 0.4rem /* 30/75 */;
      color: #999999;
      margin-left: 0.0933rem /* 7/75 */;
    }
    .icon-search {
      font-size: 0.5rem;
    }
    .c-search-input {
      width: 100%;
      border: none;
      background: transparent;
      font-size: 0.4rem;
    }
  }
}
</style>
